import sellerAvatarSrc from './pdp-seller-avatar.png'

export function PdpSellerAvatar({ className }: { className?: string }) {
  return (
    <img
      src={sellerAvatarSrc}
      alt=""
      width={48}
      height={48}
      className={`rounded-round object-cover ${className ?? ''}`}
      data-testid="muse-pdp-avatar-img"
      data-dy-id="muse-pdp-avatar"
      aria-hidden
    />
  )
}
